import Vue from 'vue';

import WidgetFieldService from '@/components/BlockEditorWidget/WidgetFieldService';
import StoreModuleService from '@/store/modules/StoreModuleService';

export const getMutationsDeclarations = () => {
	// mutations declarations
	const SET_EDIT_FIELD = 'SET_EDIT_FIELD';
	const SET_FIELD = 'SET_FIELD';
	const SET_WIDGET_ID = 'SET_WIDGET_ID';
	const SET_WIDGET_TITLE = 'SET_WIDGET_TITLE';
	const DELETE_WIDGET = 'DELETE_WIDGET';
	const SET_WIDGET_METADATA = 'SET_WIDGET_METADATA';
	const SET_WIDGET = 'SET_WIDGET';
	const UPDATE_WIDGET = 'UPDATE_WIDGET';
	const SET_EDIT_FIELD_OPTIONS = 'SET_EDIT_FIELD_OPTIONS';
	const SET_WIDGET_PROMISE = 'SET_WIDGET_PROMISE';
	const SET_WIDGET_WORKFLOW_VERSION_ID = 'SET_WIDGET_WORKFLOW_VERSION_ID';
	const IS_SAVING = 'IS_SAVING';
	const IS_LOADING_WIDGET_FIELDS = 'LOADING_WIDGET_FIELDS';
	const SET_NODE_ID = 'SET_NODE_ID';

	const declarations = {
		SET_EDIT_FIELD,
		SET_FIELD,
		SET_WIDGET_ID,
		SET_WIDGET_TITLE,
		DELETE_WIDGET,
		SET_WIDGET_METADATA,
		SET_WIDGET,
		UPDATE_WIDGET,
		SET_EDIT_FIELD_OPTIONS,
		SET_WIDGET_PROMISE,
		SET_WIDGET_WORKFLOW_VERSION_ID,
		IS_SAVING,
		IS_LOADING_WIDGET_FIELDS,
		SET_NODE_ID,
	};

	return declarations;
};

export const buildMutations = (initialState) => {
	const {
		SET_EDIT_FIELD,
		SET_FIELD,
		SET_WIDGET_ID,
		SET_WIDGET_TITLE,
		DELETE_WIDGET,
		SET_WIDGET_METADATA,
		SET_WIDGET,
		UPDATE_WIDGET,
		SET_EDIT_FIELD_OPTIONS,
		SET_WIDGET_PROMISE,
		SET_WIDGET_WORKFLOW_VERSION_ID,
		IS_SAVING,
		IS_LOADING_WIDGET_FIELDS,
		SET_NODE_ID,
	} = getMutationsDeclarations();

	const mutations = {
		...StoreModuleService.createDefaultMutations({ initializer: initialState }),
		[SET_EDIT_FIELD](state, field) {
			Vue.set(state, 'editField', field);
		},
		[SET_EDIT_FIELD_OPTIONS](state, field) {
			Vue.set(state.editField.metadata, 'options', field.metadata.options);
		},
		[SET_FIELD](state, payload) {
			const { index, field } = payload;
			Vue.set(state.widget.fields, index, field);
		},
		[SET_WIDGET_ID](state, widgetId) {
			Vue.set(state, 'widgetId', widgetId);
		},
		[SET_WIDGET_TITLE](state, widgetTitle) {
			Vue.set(state, 'widgetTitle', widgetTitle);
		},
		[DELETE_WIDGET](state, widgetId) {
			const widgetIndex = state.widget.fields.findIndex((f) => f.id === widgetId);
			if (widgetIndex === -1) return;
			Vue.delete(state.widget.fields, widgetIndex);
		},
		[SET_WIDGET_METADATA](state, value) {
			Vue.set(state, 'widgetMetadata', value);
		},
		[SET_WIDGET](state, value = {}) {
			const populatedWidgetFields = (value?.fields || []).map((field) => WidgetFieldService.populateDefaultWidgetValuesIfNeeded(field)); // Make sure widgetFields Contains all relevent fields
			const widget = { ...value, fields: populatedWidgetFields };
			Vue.set(state, 'widget', widget);
		},
		[UPDATE_WIDGET](state, value) {
			Vue.set(state, 'widget', Object.assign({}, state.widget, value));
		},
		[SET_WIDGET_PROMISE](state, promise) {
			Vue.set(state, 'saveWidgetPromise', promise);
		},
		[SET_WIDGET_WORKFLOW_VERSION_ID](state, value) {
			Vue.set(state, 'workflowVersionId', value);
		},
		[IS_SAVING](state, value) {
			Vue.set(state, 'isSavingWidget', value);
		},
		[IS_LOADING_WIDGET_FIELDS](state, value) {
			Vue.set(state, 'isLoadingWidgetFields', value);
		},
		[SET_NODE_ID](state, value) {
			Vue.set(state, 'nodeId', value);
		},
	};
	return mutations;
};
